import React from 'react';
import Button from '@mui/material/Button';
//import { useTheme } from '@mui/material/styles';
//import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import Table from '@material-ui/core/Table';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
// import TableCell from '@material-ui/core/TableCell';
// import TableBody from '@material-ui/core/TableBody';
// import Box from '@mui/material/Box';
//import Paper from '@mui/material/Paper';
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles';
import ReactEditList, * as REL from "react-edit-list";
import Link from '@mui/material/Link';

import "bootstrap/dist/css/bootstrap.min.css";
//import "../example.css";



import { set } from 'date-fns';



const theme = createTheme({
  overrides: {
    MuiTableCell: {
      root: {  //This can be referred from Material UI API documentation. 
        padding: '0px 4px',
        // backgroundColor: "#eaeaea",
      },
    },
  },
});

// const handleClipboardCopy = (url,spanId) => {
//   navigator.clipboard.writeText(url);
//   var spanItem = document.getElementById(spanId);
//   //console.log(tooltip);
//   spanItem.innerHTML = '&nbsp;&nbsp;&nbsp; Copied!';

//   setTimeout(function () {
//     spanItem.innerHTML = '';
//   }, 1000);

// };

const tooltipPrefix = 'tooltip';
const spanPrefix = 'span';


const LinkCard = (data) => {
  
  // This is the example data
  // const data = [
  //   { id: 1, Name: "Desk",Url: "http://www.microsoft.com", Click: "http://www.microsoft.com"},
  //   { id: 2, Name: "Printer",Url: "http://www.microsoft.com",Click: "http://www.microsoft.com"},
  //   { id: 3, Name: "Paper",Url: "http://www.microsoft.com",Click: "http://www.microsoft.com"},
  //   { id: 4, Name: "Chair",Url: "http://www.microsoft.com",Click: "http://www.microsoft.com"},
  //   { id: 5, Name: "Computer" ,Url: "http://www.microsoft.com",Click: "http://www.microsoft.com"},
  // ];

    //copy data from props.rows.url into props.rows.click
    data.rows.forEach(element => {
      element.click = element.url;
    });
    //console.log(data);

  // This is the schema
  const schema: REL.Schema = [
    { name: "governanceLinkId ", type: "id" },
    { name: "name", type: "string" },
    { name: "url", type: "string" },
    { name: "click", type: "string" }   
  ];
  async function saveLink(linkData, saveOrAddOrDelete, accessToken) {
    //debugger;
    var method = '';
    var url = ''
    if (saveOrAddOrDelete === 'Add') {
        method = 'POST';
        url = 'request/addLink';
    } else if (saveOrAddOrDelete === 'Save') {
        method = 'PUT';
        url = 'request/saveLink/' ;
    }
    else if (saveOrAddOrDelete === 'Delete') {
        method = 'DELETE';
        url = 'request/deleteLink/';
    }
   
    //var bearer = 'Bearer ' + accessToken;

    try {
        const requestOptions = {
            method: method,
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(linkData)
        };

        var result = await fetch(url, requestOptions);
        //console.log(result);

        if (result.status === 500) {
            //showError("Error saving Network System");
        } else if (result.status === 404) {
            //showError("Error saving Network System");
        }

        return result;
    } catch (e) {
      console.log(e);
        //showError();
    } finally {
        //setRefreshGrid(refreshGrid + 1);
        //reRender = reRender + 1;
        //console.log(reRender);
    }
}

  return (
    <React.Fragment>

      <ThemeProvider theme={theme}>
        <Title>{data.title}</Title>

        {/* {props.rows.map((report, index) => <div key = {index}><a href={report.reportUrl} target='_blank' rel="noreferrer">{report.reportName}  </a><Tooltip id ={tooltipPrefix+index} title = 'Click to copy URL for sharing'><Button onClick={() =>  handleClipboardCopy(report.reportUrl,spanPrefix+index)}><ContentCopyIcon  ></ContentCopyIcon> <span id={spanPrefix+index}></span> </Button></Tooltip> (run {report.invoked} times)</div>)} */}
        {/* {props.rows.map((report, index) => <p>{report.reportName}</p>} */}
        <ReactEditList
          schema={schema}
          onLoad={() => data.rows}
          onUpdate={(item) => {
            saveLink(item, 'Save', data.accessToken);
            //Click should be updated with the Url value
            item.click = item.url;
            //console.log("UPDATE", item);
            return true;
          }}
          onDelete={(item) => {
            if (!window.confirm("Are you sure you want to delete "+item.name+"?")) return false;
            saveLink(item, 'Delete', data.accessToken);
            //console.log("DELETE", item);
          }}
          onInsert={(item) => {
            // Call your API here
            item.click = item.url;
            var response = saveLink(item, 'Add', data.accessToken);
            return true;
            //console.log("INSERT", response);
          }}
          
          className="table table-light table-fixed align-middle"
          headClassName="table-bordered"
          inputClassName="w-100"
          thClassName={{
            // These allow to fix the column widths
            url: "col-8",
            // type: "col-3",
            name: "col-4",
            // stock: "col-2",
            //click: "col-4",
          }}
          btnValidateClassName="btn btn-success p-0 m-0"
          btnDeleteClassName="btn btn-danger py-0 px-1 m-0 mx-1"
          btnCancelClassName="btn btn-secondary py-0 px-1 m-0 mx-1"
          format={{
            click: function URLRenderer(props) {
              //return button link
              
              return <button className="btn btn-primary" 
              target='_blank' 
              href={props.value}
              component="button"
              variant="body2"
              onClick={(event) => {
                //alert('Edit PIA' + row.id);
                 window.open(props.value, '_blank');
              
              }}
            >
              Go
            </button>
              //return <a target='_blank' href={props.value}> {props.value}</a>;
            },
          }}
          edit={{
            click: function URLEditor(props) {
              return <button className="btn btn-primary" 
              target='_blank' 
              href={props.value}
              component="button"
              variant="body2"
              onClick={(event) => {
                //alert('Edit PIA' + row.id);
                 window.open(props.value, '_blank');
              
              }}
            >
             Go
            </button>
              //return <a target='_blank' href={props.value}> {props.value}</a>;
            }
          }}
          // btnDeleteElement={<button className="btn btn-danger">REMOVE</button>}
        />


      </ThemeProvider>
    </React.Fragment>
  );
}
export default LinkCard;